/**
 * @ngdoc services
 * @memberof mercury.modules.settings
 * @name Payments
 * @description Data access service for Loaded Subscription payments
 */
angular.module('mercury.modules.settings.billing')
.factory('Payments', ["$http", "settings", function($http, settings) {

  /**
   * Get details of Payment types (Monthly, Annual)
   *
   * @memberof Payments
   */
  function getTypes() {
    return $http.get(settings.apiHost + '/r/Payments');
  }

  /**
   * Get the payment express url to use in the IFrame to allow payment of a subscription
   *
   * @memberof Payments
   * @param  {String} type      Payment type id to pay for
   * @param  {String} companyId Id of the company to make payment for
   */
  function getRequestUrl(type, companyId) {
    return $http.get(settings.apiHost + '/a/Payments/GetRequestUrl', {params: {subscriptionType: type}, headers: {'x-loaded-company-id': companyId}});
  }

  return {
    getTypes: getTypes,
    getRequestUrl: getRequestUrl
  };
}]);
